<template>
  <b-modal v-model="showModal" :title="$t('simple.automation_edit_message')" @hide="$emit('close')" size="lg">
    <template #modal-header>
      <h5 class="modal-title">{{$t('simple.greeting_message_title', {account_name:account.name}) }}</h5>
      <b-button variant="outline-danger" size="sm" @click="closeModal">&times;</b-button>
    </template>

    <b-form-group label="Edit Message Content">
      <b-form-textarea
          name="template_message_content"
          ref="template_message_content"
          v-model="messageContent"
          rows="5"
          max-rows="6"
         >
      </b-form-textarea>
    </b-form-group>
    <b-form-group>
      <b-row class="align-items-center mb-3">
        <b-col sm="12" lg="1">
          <label for="template_message_media">{{ $t('simple.file') }}:</label>
        </b-col>
        <b-col sm="6" lg="5" class="mb-3">
          <div :class="{ 'isInvalid': !file }"
               class="media-upload-container d-flex justify-content-center align-items-center">
            <div class="position-absolute">
              <div class="d-flex flex-column align-items-center text-center">
                <font-awesome-icon :icon="'folder-open'" class="text-primary" />
                <span class="media-upload-inner-container text-muted font-weight-normal"
                      v-if="!file_url">{{ $t('macros.attach_file') }}</span>
                <span class="media-upload-inner-container text-muted font-weight-normal"
                      v-else>{{ $t('macros.change_file') }}</span>
                <span
                    class="media-upload-inner-container text-muted font-weight-normal">(JPEG
                                                            or PNG or Video)</span>
                <span class="media-upload-inner-container text-muted font-weight-normal">
                                                            (Max 5MB Image , Max 16MB Video)</span>
              </div>
            </div>
            <b-form-file id="template_message_media" v-model="file"
                         :accept="accepted_types" plain
                         @input="addFile(file)"
                         class="media-upload-button h-100 w-100">
            </b-form-file>
          </div>
        </b-col>
        <b-col sm="6" lg="5" v-if="file_url && file_type == 'video'" class="mb-3">
          <div class="position-relative media-preview-container">
            <a href="#" @click="video_view(existFile ? existFile : file_url)">
            <video :src="file_url" class="media-preview"> </video>
            </a>
            <font-awesome-icon :icon="'play-circle'"
                               class="preview-video-button position-absolute p-0" />
            <b-btn size="sm" class="preview-remove-button position-absolute" variant="danger"
                   @click="removeFile">
              <font-awesome-icon :icon="'times'" />
            </b-btn>

          </div>
        </b-col>
        <b-col sm="4" v-if="file_url && file_type == 'image'" class="mb-3">
          <div class="position-relative media-preview-container">
            <a href="#" @click="image_view(existFile ? existFile : file_url)">
            <b-img  fluid :src="file_url" class="media-preview" />
            </a>
            <b-btn size="sm" class="preview-remove-button position-absolute" variant="danger"
                   @click="removeFile">
              <font-awesome-icon :icon="'times'" />
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </b-form-group>

    <template #modal-footer>
      <b-button variant="primary" @click="saveMessage">{{$t('default.save')}}</b-button>
      <b-button variant="secondary" @click="closeModal">{{$t('default.cancel')}}</b-button>
    </template>
  </b-modal>
</template>

<script>
import {create} from "vue-modal-dialogs";
import ImageView from "./ImageView.vue";
import VideoView from "./VideoView.vue";

export default {
  name:'greeting-message',
  props: {
    account: Object,
  },

  data() {
    return {
      file: null,
      file_url: this.account.automation.file?.url.public ,
      existFile: this.account.automation.file,
      remove_attachment: false,
      file_type:this.account.automation.file?.type ,
      showModal: true,
      messageContent: this.account.automation.message_content,
      accepted_types:"image/jpeg, image/jpg, image/png, video/mp4, video/3gpp",
      limit_size_for_video: 16,
      limit_size_for_image: 5,
    };
  },
  created() {
    this.file_type = this.account.automation.file?.type ;
    this.file_url = this.account.automation.file?.url?.public;

    console.log('account:',this.account)
    console.log('file_url:',this.file_url)
    console.log('file_type:',this.file_type)
  },
  methods: {
    checkFileSize(file, size_limit) {
      if (((file.size / 1024) / 1024).toFixed(4) > size_limit) {
        return false
      }

      return true
    },
    addFile(file) {
      if (file) {
        if (file.type.startsWith('image/')) {
          this.file_type = 'image';
        } else if (file.type.startsWith('video/')) {
          this.file_type = 'video';
        }
        if (this.checkFileSize(file, this.file_type === 'image' ? this.limit_size_for_image : this.limit_size_for_video)) {
          this.file_url = URL.createObjectURL(file);
          console.log('uploade image',this.file_url)
           this.existFile = null;
        } else {
          Vue.toasted.error(this.$t('macros.size_limit_alert', {
            size_limit: this.file_type === 'image' ? this.limit_size_for_image : this.limit_size_for_video,
          }));

          this.removeFile();
        }
      }
    },
    image_view: async function (attachment) {

      // Show image modal
      const image_view = create(ImageView, 'attachment');

      if (await image_view(attachment)) {
        // Nothing here yet

      }
    },

    // Play video
    video_view: async function (attachment) {

      // Show video modal
      const video_view = create(VideoView, 'attachment');

      if (await video_view(attachment)) {
        // Nothing here yet

      }
    },
    removeFile() {
      this.file = null;
      this.file_url = '';
      this.remove_attachment = true
    },
    saveMessage() {
      this.$emit('save', { accountId: this.account.id, content: this.messageContent ,remove_attachment:this.remove_attachment, attachment:this.file});
      this.closeModal();
    },

    closeModal() {
      this.showModal = false;
      this.$emit('close');
    },
  },
};
</script>
